import React from "react";
import Header from "../Header/header";
import Footer from "../Footer/footer";
import AMNBanner from "../../Assets/images/AMN-Banner.jpg";
// import { useParams } from 'react-router-dom';

export default function MunasibaatDetail() {
  // const { id } = useParams();
  // Dummy data for demonstration
  const dummyData = {
    title: "نمونہ مناسبت",
    date: "2024-05-01",
    description:
      "یہ ایک ڈمی تفصیل ہے جو مناسبت کی تفصیلات کے صفحہ کے لئے استعمال ہو رہی ہے۔",
    highlights:
      "یہاں پر آئندہ منعقد ہونے والے پروگرامز اور منصوبہ بند تقریبات کی تفصیلات دی جائیں گی۔",
    image: AMNBanner,
  };

  return (
    <>
      <Header />
      <div
        dir="rtl"
        className="bg-white min-h-screen w-full mt-5 px-3 sm:px-6 md:px-10 lg:px-20 text-black text-center font-nastaleeqRegular font-normal tracking-[0.1rem] leading-[2.5rem]"
      >
        <div className="pt-10 sm:pt-16 md:pt-20 flex flex-col gap-12 md:gap-10">
          <section className="bg-primaryBG rounded-3xl flex flex-col lg:flex-row justify-center lg:justify-between items-center gap-8 md:gap-10 py-8 sm:py-10 md:py-12 px-3 sm:px-6 md:px-10 lg:px-20">
            <div className="w-full lg:w-1/2 text-right flex flex-col gap-4 order-2 lg:order-1">
              <h1 className="font-nastaleeqKasheeda text-2xl sm:text-3xl md:text-4xl lg:text-4xl text-right mb-2 lg:mb-4">
                {dummyData.title}
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl lg:text-2xl font-nastaleeqRegular max-w-xl leading-relaxed">
                {dummyData.description}
              </p>
            </div>
            <div className="w-full lg:w-1/2 flex justify-center items-center order-1 lg:order-2">
              <img
                src={dummyData.image}
                alt={dummyData.title}
                className="mx-auto max-w-xs md:max-w-sm lg:max-w-md w-full h-auto mt-4 rounded-2xl"
              />
            </div>
          </section>
          <section className="bg-white rounded-3xl p-6 md:p-10">
            <h4 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-nastaleeqKasheeda mb-6">
              مناسبت کی تفصیلات
            </h4>
            <p className="text-lg sm:text-xl md:text-2xl lg:text-2xl text-right font-nastaleeqRegular">
              {dummyData.highlights}
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
}
